import { useConfig } from '@hooks/other/useConfig';
import { useGetBackendVersion } from '@hooks/queries/useGetBackendVersion';
import { useGetSpliceVersion } from '@hooks/queries/useGetSpliceVersion';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { PackageName } from '../../../config/package';
import { PackageDisplay } from './PackageDisplay';
import { VersionRow } from './VersionRow';

const dtcDarPackages = [
  PackageName.RegistryApp,
  PackageName.Registry,
  PackageName.RegistryHolding,
  PackageName.Credential,
];

const SectionTitle: React.FC<{ title: string }> = ({ title }) => (
  <Typography sx={{ mb: 1 }} color="primary" variant="h4" fontWeight="bold">
    {title}
  </Typography>
);

const DarDisplay: React.FC<{ packageName: PackageName }> = ({ packageName }) => (
  <Box sx={{ mb: 2 }}>
    <Typography sx={{ textTransform: 'capitalize', mb: 1 }} fontWeight="bold">
      {packageName} DAR
    </Typography>
    <PackageDisplay packageName={packageName} />
  </Box>
);

export const Versions: React.FC = () => {
  const config = useConfig();
  const backendVersion = useGetBackendVersion();
  const spliceVersion = useGetSpliceVersion();

  return (
    <Box sx={{ maxWidth: '800px' }}>
      <Box sx={{ mb: 3 }}>
        <SectionTitle title="CTS Frontend" />
        <VersionRow label="Version" value={config.app.version} />
        <VersionRow label="dApp SDK" value={__DAPP_SDK_VERSION__} />
      </Box>

      <Box sx={{ mb: 3 }}>
        <SectionTitle title="CTS Backend" />
        <VersionRow
          label="Version"
          value={backendVersion.data}
          isLoading={backendVersion.isLoading}
        />
      </Box>

      <Box sx={{ mb: 3 }}>
        <SectionTitle title="Splice" />
        <VersionRow
          label="Splice node version"
          value={spliceVersion.data}
          isLoading={spliceVersion.isLoading}
        />
        <DarDisplay packageName={PackageName.Splice} />
      </Box>

      <Box sx={{ mb: 3 }}>
        <SectionTitle title="DTC DARs" />
        {dtcDarPackages.map((p) => (
          <DarDisplay packageName={p} key={p} />
        ))}
      </Box>
    </Box>
  );
};
